// Imports
import { configureStore } from "@reduxjs/toolkit";
import { navSelectionReducer } from "../features/navSelection";
import { hubSelectionReducer } from "../features/hubSelection";
import { vendorProfileReducer } from "../features/vendorProfile";
import { SliceNames } from "./Constants";

// Create store
export const store = configureStore({
  reducer: {
    [SliceNames.NAV_SELECTION_INDEX]: navSelectionReducer,
    [SliceNames.HUB_SELECTION_DATA]: hubSelectionReducer,
    [SliceNames.VENDOR_PROFILE]: vendorProfileReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
});